import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsReportsUnsubscribeRoute: InvariantJiraRoute = {
	name: 'assets-reports-unsubscribe',
	path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
	exact: true,
};
